/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ApClassAttendanceRef,
  ApClassAttendanceRefOptional,
  ApClassAttendanceRefMetaI,
  ApClassAttendanceRefTrackedI,
} from "./ap-class-attendance-ref";
import {
  ApClassAttendanceRefTracked,
  ApClassAttendanceRefMeta,
} from "./ap-class-attendance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ApClassInstanceRef,
  ApClassInstanceRefOptional,
  ApClassInstanceRefMetaI,
  ApClassInstanceRefTrackedI,
} from "./ap-class-instance-ref";
import {
  ApClassInstanceRefTracked,
  ApClassInstanceRefMeta,
} from "./ap-class-instance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ApClassSignupFull,
  ApClassSignupFullOptional,
  ApClassSignupFullMetaI,
  ApClassSignupFullTrackedI,
} from "./ap-class-signup-full";
import {
  ApClassSignupFullTracked,
  ApClassSignupFullMeta,
} from "./ap-class-signup-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ApClassWlResultFull,
  ApClassWlResultFullOptional,
  ApClassWlResultFullMetaI,
  ApClassWlResultFullTrackedI,
} from "./ap-class-wl-result-full";
import {
  ApClassWlResultFullTracked,
  ApClassWlResultFullMeta,
} from "./ap-class-wl-result-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  MembershipRef,
  MembershipRefOptional,
  MembershipRefMetaI,
  MembershipRefTrackedI,
} from "./membership-ref";
import { MembershipRefTracked, MembershipRefMeta } from "./membership-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchasableState,
  PurchasableStateOptional,
  PurchasableStateMetaI,
  PurchasableStateTrackedI,
} from "./purchasable-state";
import {
  PurchasableStateTracked,
  PurchasableStateMeta,
} from "./purchasable-state";
// May contain unused imports in some cases
// @ts-ignore
import type {
  SignupTypeEnum,
  SignupTypeEnumOptional,
  SignupTypeEnumMetaI,
  SignupTypeEnumTrackedI,
} from "./signup-type-enum";
import { SignupTypeEnumTracked, SignupTypeEnumMeta } from "./signup-type-enum";

/**
 *
 * @export
 * @interface PurchaseClassSignupDTO
 */
export interface PurchaseClassSignupDTOOptional extends ApClassSignupFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof PurchaseClassSignupDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseClassSignupDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseClassSignupDTO
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof PurchaseClassSignupDTO
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof PurchaseClassSignupDTO
   */
  signupDatetime?: Date;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof PurchaseClassSignupDTO
   */
  signupType?: SignupTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PurchaseClassSignupDTO
   */
  signupNote?: string;
  /**
   *
   * @type {number}
   * @memberof PurchaseClassSignupDTO
   */
  sequence?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof PurchaseClassSignupDTO
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof PurchaseClassSignupDTO
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof PurchaseClassSignupDTO
   */
  voidCloseId?: number;
  /**
   *
   * @type {PersonRef}
   * @memberof PurchaseClassSignupDTO
   */
  personId?: PersonRefOptional;
  /**
   *
   * @type {ApClassInstanceRef}
   * @memberof PurchaseClassSignupDTO
   */
  instanceId?: ApClassInstanceRefOptional;
  /**
   *
   * @type {ApClassWlResultFull}
   * @memberof PurchaseClassSignupDTO
   */
  wlResult?: ApClassWlResultFullOptional;
  /**
   *
   * @type {Array<ApClassAttendanceRef>}
   * @memberof PurchaseClassSignupDTO
   */
  attendance?: ApClassAttendanceRefOptional[];
  /**
   *
   * @type {MembershipRef}
   * @memberof PurchaseClassSignupDTO
   */
  membershipUsed?: MembershipRefOptional;
}

export interface PurchaseClassSignupDTO
  extends PurchaseClassSignupDTOOptional, ApClassSignupFull {
  /**
   *
   * @type {boolean}
   * @memberof PurchaseClassSignupDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseClassSignupDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseClassSignupDTO
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof PurchaseClassSignupDTO
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof PurchaseClassSignupDTO
   */
  signupDatetime?: Date;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof PurchaseClassSignupDTO
   */
  signupType?: SignupTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PurchaseClassSignupDTO
   */
  signupNote?: string;
  /**
   *
   * @type {number}
   * @memberof PurchaseClassSignupDTO
   */
  sequence?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof PurchaseClassSignupDTO
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof PurchaseClassSignupDTO
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof PurchaseClassSignupDTO
   */
  voidCloseId?: number;
  /**
   *
   * @type {PersonRef}
   * @memberof PurchaseClassSignupDTO
   */
  personId: PersonRef;
  /**
   *
   * @type {ApClassInstanceRef}
   * @memberof PurchaseClassSignupDTO
   */
  instanceId: ApClassInstanceRef;
  /**
   *
   * @type {ApClassWlResultFull}
   * @memberof PurchaseClassSignupDTO
   */
  wlResult?: ApClassWlResultFull;
  /**
   *
   * @type {Array<ApClassAttendanceRef>}
   * @memberof PurchaseClassSignupDTO
   */
  attendance?: ApClassAttendanceRef[];
  /**
   *
   * @type {MembershipRef}
   * @memberof PurchaseClassSignupDTO
   */
  membershipUsed?: MembershipRef;
}

export interface PurchaseClassSignupDTOTrackedI extends ApClassSignupFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof PurchaseClassSignupDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseClassSignupDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseClassSignupDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseClassSignupDTO
   */
  price?: number;
  priceIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PurchaseClassSignupDTO
   */
  signupDatetime?: Date;
  signupDatetimeIsSet: boolean;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof PurchaseClassSignupDTO
   */
  signupType?: SignupTypeEnum;
  signupTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PurchaseClassSignupDTO
   */
  signupNote?: string;
  signupNoteIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseClassSignupDTO
   */
  sequence?: number;
  sequenceIsSet: boolean;
  /**
   *
   * @type {PurchasableState}
   * @memberof PurchaseClassSignupDTO
   */
  purchasableState?: PurchasableState;
  purchasableStateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PurchaseClassSignupDTO
   */
  purchaseDate?: Date;
  purchaseDateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseClassSignupDTO
   */
  voidCloseId?: number;
  voidCloseIdIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof PurchaseClassSignupDTO
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
  /**
   *
   * @type {ApClassInstanceRef}
   * @memberof PurchaseClassSignupDTO
   */
  instanceId?: ApClassInstanceRefTrackedI;
  instanceIdIsSet: boolean;
  /**
   *
   * @type {ApClassWlResultFull}
   * @memberof PurchaseClassSignupDTO
   */
  wlResult?: ApClassWlResultFullTrackedI;
  wlResultIsSet: boolean;
  /**
   *
   * @type {Array<ApClassAttendanceRef>}
   * @memberof PurchaseClassSignupDTO
   */
  attendance?: ApClassAttendanceRefTrackedI[];
  attendanceIsSet: boolean;
  /**
   *
   * @type {MembershipRef}
   * @memberof PurchaseClassSignupDTO
   */
  membershipUsed?: MembershipRefTrackedI;
  membershipUsedIsSet: boolean;
}

transformDatesMap.set(
  "PurchaseClassSignupDTO",
  function (model: PurchaseClassSignupDTO) {
    if (typeof model.signupDatetime == "string")
      model.signupDatetime = new Date(model.signupDatetime);
    if (typeof model.purchaseDate == "string")
      model.purchaseDate = new Date(model.purchaseDate);
    const transformDatespersonId = transformDatesMap.get("PersonRef");
    if (transformDatespersonId && model.personId) {
      transformDatespersonId(model.personId);
    }
    const transformDatesinstanceId =
      transformDatesMap.get("ApClassInstanceRef");
    if (transformDatesinstanceId && model.instanceId) {
      transformDatesinstanceId(model.instanceId);
    }
    const transformDateswlResult = transformDatesMap.get("ApClassWlResultFull");
    if (transformDateswlResult && model.wlResult) {
      transformDateswlResult(model.wlResult);
    }
    const transformDatesattendance = transformDatesMap.get(
      "ApClassAttendanceRef",
    );
    if (transformDatesattendance) {
      model.attendance?.forEach((sub) => {
        transformDatesattendance(sub);
      });
    }
    const transformDatesmembershipUsed = transformDatesMap.get("MembershipRef");
    if (transformDatesmembershipUsed && model.membershipUsed) {
      transformDatesmembershipUsed(model.membershipUsed);
    }
  },
);

export type PurchaseClassSignupDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  price: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  signupDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  signupType: PropertyMeta<SignupTypeEnumMetaI>;
  //isDate: false
  //isDatetime: false
  signupNote: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  sequence: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  purchasableState: PropertyMeta<PurchasableStateMetaI>;
  //isDate: false
  //isDatetime: true
  purchaseDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  voidCloseId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
  //isDate: false
  //isDatetime: false
  instanceId: PropertyMeta<ApClassInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  wlResult: PropertyMeta<ApClassWlResultFullMetaI>;
  //isDate: false
  //isDatetime: false
  attendance: PropertyMeta<ApClassAttendanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  membershipUsed: PropertyMeta<MembershipRefMetaI>;
}>;

export var PurchaseClassSignupDTOMeta: PurchaseClassSignupDTOMetaI =
  {} as PurchaseClassSignupDTOMetaI;
PurchaseClassSignupDTOMeta = typeMeta("PurchaseClassSignupDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  price: propertyMeta("price", false, false, false, MetaTypesBase.number),
  signupDatetime: propertyMeta(
    "signupDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  signupType: propertyMeta(
    "signupType",
    false,
    false,
    false,
    SignupTypeEnumMeta,
  ),
  signupNote: propertyMeta(
    "signupNote",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  sequence: propertyMeta("sequence", false, false, false, MetaTypesBase.number),
  purchasableState: propertyMeta(
    "purchasableState",
    false,
    false,
    false,
    PurchasableStateMeta,
  ),
  purchaseDate: propertyMeta(
    "purchaseDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  voidCloseId: propertyMeta(
    "voidCloseId",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  personId: propertyMeta("personId", false, true, false, PersonRefMeta),
  instanceId: propertyMeta(
    "instanceId",
    false,
    true,
    false,
    ApClassInstanceRefMeta,
  ),
  wlResult: propertyMeta(
    "wlResult",
    false,
    false,
    false,
    ApClassWlResultFullMeta,
  ),
  attendance: propertyMeta(
    "attendance",
    true,
    false,
    false,
    ApClassAttendanceRefMeta,
  ),
  membershipUsed: propertyMeta(
    "membershipUsed",
    false,
    false,
    false,
    MembershipRefMeta,
  ),
});

const metaI = PurchaseClassSignupDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ApClassSignupFullMeta]);
  metaI.isDeleted.inheritedFrom = ApClassSignupFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = ApClassSignupFullMeta.isNew;
  metaI.assignId.inheritedFrom = ApClassSignupFullMeta.assignId;
  metaI.price.inheritedFrom = ApClassSignupFullMeta.price;
  metaI.signupDatetime.inheritedFrom = ApClassSignupFullMeta.signupDatetime;
  metaI.signupType.inheritedFrom = ApClassSignupFullMeta.signupType;
  metaI.signupNote.inheritedFrom = ApClassSignupFullMeta.signupNote;
  metaI.sequence.inheritedFrom = ApClassSignupFullMeta.sequence;
  metaI.purchasableState.inheritedFrom = ApClassSignupFullMeta.purchasableState;
  metaI.purchaseDate.inheritedFrom = ApClassSignupFullMeta.purchaseDate;
  metaI.voidCloseId.inheritedFrom = ApClassSignupFullMeta.voidCloseId;
  metaI.personId.inheritedFrom = ApClassSignupFullMeta.personId;
  metaI.instanceId.inheritedFrom = ApClassSignupFullMeta.instanceId;
  metaI.wlResult.inheritedFrom = ApClassSignupFullMeta.wlResult;
  metaI.attendance.inheritedFrom = ApClassSignupFullMeta.attendance;
  metaI.membershipUsed.inheritedFrom = ApClassSignupFullMeta.membershipUsed;
});

export class PurchaseClassSignupDTOTracked
  extends ApClassSignupFullTracked
  implements PurchaseClassSignupDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  price__I?: number = undefined;
  priceIsSet: boolean = false;
  set price(v: undefined | number) {
    if (v !== undefined) {
      this.price__I = v;
      this.priceIsSet = true;
    } else {
      this.price__I = v || undefined;
      this.priceIsSet = false;
    }
    this.changeTracker = true;
  }
  get price() {
    return this.price__I;
  }
  signupDatetime__I?: Date = undefined;
  signupDatetimeIsSet: boolean = false;
  set signupDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.signupDatetime__I = v;
      this.signupDatetimeIsSet = true;
    } else {
      this.signupDatetime__I = v || undefined;
      this.signupDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupDatetime() {
    return this.signupDatetime__I;
  }
  signupType__I?: SignupTypeEnum = undefined;
  signupTypeIsSet: boolean = false;
  set signupType(v: undefined | SignupTypeEnum) {
    if (v !== undefined) {
      this.signupType__I = v;
      this.signupTypeIsSet = true;
    } else {
      this.signupType__I = v || undefined;
      this.signupTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupType() {
    return this.signupType__I;
  }
  signupNote__I?: string = undefined;
  signupNoteIsSet: boolean = false;
  set signupNote(v: undefined | string) {
    if (v !== undefined) {
      this.signupNote__I = v;
      this.signupNoteIsSet = true;
    } else {
      this.signupNote__I = v || undefined;
      this.signupNoteIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupNote() {
    return this.signupNote__I;
  }
  sequence__I?: number = undefined;
  sequenceIsSet: boolean = false;
  set sequence(v: undefined | number) {
    if (v !== undefined) {
      this.sequence__I = v;
      this.sequenceIsSet = true;
    } else {
      this.sequence__I = v || undefined;
      this.sequenceIsSet = false;
    }
    this.changeTracker = true;
  }
  get sequence() {
    return this.sequence__I;
  }
  purchasableState__I?: PurchasableState = undefined;
  purchasableStateIsSet: boolean = false;
  set purchasableState(v: undefined | PurchasableState) {
    if (v !== undefined) {
      this.purchasableState__I = v;
      this.purchasableStateIsSet = true;
    } else {
      this.purchasableState__I = v || undefined;
      this.purchasableStateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchasableState() {
    return this.purchasableState__I;
  }
  purchaseDate__I?: Date = undefined;
  purchaseDateIsSet: boolean = false;
  set purchaseDate(v: undefined | Date) {
    if (v !== undefined) {
      this.purchaseDate__I = v;
      this.purchaseDateIsSet = true;
    } else {
      this.purchaseDate__I = v || undefined;
      this.purchaseDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchaseDate() {
    return this.purchaseDate__I;
  }
  voidCloseId__I?: number = undefined;
  voidCloseIdIsSet: boolean = false;
  set voidCloseId(v: undefined | number) {
    if (v !== undefined) {
      this.voidCloseId__I = v;
      this.voidCloseIdIsSet = true;
    } else {
      this.voidCloseId__I = v || undefined;
      this.voidCloseIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get voidCloseId() {
    return this.voidCloseId__I;
  }
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  instanceId__I?: ApClassInstanceRefTracked = undefined;
  instanceIdIsSet: boolean = false;
  set instanceId(v: undefined | ApClassInstanceRefTracked) {
    if (v !== undefined) {
      this.instanceId__I = v;
      this.instanceIdIsSet = true;
    } else {
      this.instanceId__I = v || undefined;
      this.instanceIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get instanceId() {
    return this.instanceId__I;
  }
  wlResult__I?: ApClassWlResultFullTracked = undefined;
  wlResultIsSet: boolean = false;
  set wlResult(v: undefined | ApClassWlResultFullTracked) {
    if (v !== undefined) {
      this.wlResult__I = v;
      this.wlResultIsSet = true;
    } else {
      this.wlResult__I = v || undefined;
      this.wlResultIsSet = false;
    }
    this.changeTracker = true;
  }
  get wlResult() {
    return this.wlResult__I;
  }
  attendance__I?: ApClassAttendanceRefTracked[] = undefined;
  attendanceIsSet: boolean = false;
  set attendance(v: undefined | ApClassAttendanceRefTracked[]) {
    if (v !== undefined) {
      this.attendance__I = v;
      this.attendanceIsSet = true;
    } else {
      this.attendance__I = v || undefined;
      this.attendanceIsSet = false;
    }
    this.changeTracker = true;
  }
  get attendance() {
    return this.attendance__I;
  }
  membershipUsed__I?: MembershipRefTracked = undefined;
  membershipUsedIsSet: boolean = false;
  set membershipUsed(v: undefined | MembershipRefTracked) {
    if (v !== undefined) {
      this.membershipUsed__I = v;
      this.membershipUsedIsSet = true;
    } else {
      this.membershipUsed__I = v || undefined;
      this.membershipUsedIsSet = false;
    }
    this.changeTracker = true;
  }
  get membershipUsed() {
    return this.membershipUsed__I;
  }
  constructor(
    config?: PurchaseClassSignupDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.personId?.setIds();

    this.instanceId?.setIds();

    this.wlResult?.setIds();

    this.attendance?.forEach((a) => a.setIds());
    this.membershipUsed?.setIds();
  }
  assignFrom(
    config: PurchaseClassSignupDTOOptional,
    options?: AssignOptions,
  ): PurchaseClassSignupDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.price && this.priceApplyFilter(optionsRequired.filter)) {
      this.price = config.price;
      if (optionsRequired.unassign) this.priceIsSet = false;
      else this.priceIsSet = true;
    }
    if (
      config.signupDatetime &&
      this.signupDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.signupDatetime = config.signupDatetime;
      if (optionsRequired.unassign) this.signupDatetimeIsSet = false;
      else this.signupDatetimeIsSet = true;
    }
    if (
      config.signupType &&
      this.signupTypeApplyFilter(optionsRequired.filter)
    ) {
      this.signupType = config.signupType;
      if (optionsRequired.unassign) this.signupTypeIsSet = false;
      else this.signupTypeIsSet = true;
    }
    if (
      config.signupNote &&
      this.signupNoteApplyFilter(optionsRequired.filter)
    ) {
      this.signupNote = config.signupNote;
      if (optionsRequired.unassign) this.signupNoteIsSet = false;
      else this.signupNoteIsSet = true;
    }
    if (config.sequence && this.sequenceApplyFilter(optionsRequired.filter)) {
      this.sequence = config.sequence;
      if (optionsRequired.unassign) this.sequenceIsSet = false;
      else this.sequenceIsSet = true;
    }
    if (
      config.purchasableState &&
      this.purchasableStateApplyFilter(optionsRequired.filter)
    ) {
      this.purchasableState = config.purchasableState;
      if (optionsRequired.unassign) this.purchasableStateIsSet = false;
      else this.purchasableStateIsSet = true;
    }
    if (
      config.purchaseDate &&
      this.purchaseDateApplyFilter(optionsRequired.filter)
    ) {
      this.purchaseDate = config.purchaseDate;
      if (optionsRequired.unassign) this.purchaseDateIsSet = false;
      else this.purchaseDateIsSet = true;
    }
    if (
      config.voidCloseId &&
      this.voidCloseIdApplyFilter(optionsRequired.filter)
    ) {
      this.voidCloseId = config.voidCloseId;
      if (optionsRequired.unassign) this.voidCloseIdIsSet = false;
      else this.voidCloseIdIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (
      config.instanceId &&
      this.instanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.instanceId = new ApClassInstanceRefTracked(
        config.instanceId,
        options,
      );
      if (optionsRequired.unassign) this.instanceIdIsSet = false;
      else this.instanceIdIsSet = true;
    }
    if (config.wlResult && this.wlResultApplyFilter(optionsRequired.filter)) {
      this.wlResult = new ApClassWlResultFullTracked(config.wlResult, options);
      if (optionsRequired.unassign) this.wlResultIsSet = false;
      else this.wlResultIsSet = true;
    }
    if (
      config.attendance &&
      this.attendanceApplyFilter(optionsRequired.filter)
    ) {
      this.attendance = config.attendance?.map(
        (a) => new ApClassAttendanceRefTracked(a, options),
      );
      if (optionsRequired.unassign) this.attendanceIsSet = false;
      else this.attendanceIsSet = true;
    }
    if (
      config.membershipUsed &&
      this.membershipUsedApplyFilter(optionsRequired.filter)
    ) {
      this.membershipUsed = new MembershipRefTracked(
        config.membershipUsed,
        options,
      );
      if (optionsRequired.unassign) this.membershipUsedIsSet = false;
      else this.membershipUsedIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PurchaseClassSignupDTOTrackedI {
    const cloned = {} as PurchaseClassSignupDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.priceIsSetDeep() &&
      this.priceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceIsSet = true;
      cloned.price = this.price;
    } else {
      //cloned.priceIsSet = false
    }
    if (
      this.signupDatetimeIsSetDeep() &&
      this.signupDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupDatetimeIsSet = true;
      cloned.signupDatetime = this.signupDatetime;
    } else {
      //cloned.signupDatetimeIsSet = false
    }
    if (
      this.signupTypeIsSetDeep() &&
      this.signupTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupTypeIsSet = true;
      cloned.signupType = this.signupType;
    } else {
      //cloned.signupTypeIsSet = false
    }
    if (
      this.signupNoteIsSetDeep() &&
      this.signupNoteApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupNoteIsSet = true;
      cloned.signupNote = this.signupNote;
    } else {
      //cloned.signupNoteIsSet = false
    }
    if (
      this.sequenceIsSetDeep() &&
      this.sequenceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sequenceIsSet = true;
      cloned.sequence = this.sequence;
    } else {
      //cloned.sequenceIsSet = false
    }
    if (
      this.purchasableStateIsSetDeep() &&
      this.purchasableStateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchasableStateIsSet = true;
      cloned.purchasableState = this.purchasableState;
    } else {
      //cloned.purchasableStateIsSet = false
    }
    if (
      this.purchaseDateIsSetDeep() &&
      this.purchaseDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchaseDateIsSet = true;
      cloned.purchaseDate = this.purchaseDate;
    } else {
      //cloned.purchaseDateIsSet = false
    }
    if (
      this.voidCloseIdIsSetDeep() &&
      this.voidCloseIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.voidCloseIdIsSet = true;
      cloned.voidCloseId = this.voidCloseId;
    } else {
      //cloned.voidCloseIdIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (
      this.instanceIdIsSetDeep() &&
      this.instanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instanceIdIsSet = true;
      cloned.instanceId = this.instanceId?.removeUnset(filter);
    } else {
      //cloned.instanceIdIsSet = false
    }
    if (
      this.wlResultIsSetDeep() &&
      this.wlResultApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.wlResultIsSet = true;
      cloned.wlResult = this.wlResult?.removeUnset(filter);
    } else {
      //cloned.wlResultIsSet = false
    }
    if (
      this.attendanceIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.attendanceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.attendanceIsSet = true;
      cloned.attendance = this.attendance
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.attendanceIsSet = false
    }
    if (
      this.membershipUsedIsSetDeep() &&
      this.membershipUsedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.membershipUsedIsSet = true;
      cloned.membershipUsed = this.membershipUsed?.removeUnset(filter);
    } else {
      //cloned.membershipUsedIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PurchaseClassSignupDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.priceApplyFilter(filter)) this.priceIsSet = false;

    if (!this.signupDatetimeApplyFilter(filter))
      this.signupDatetimeIsSet = false;

    if (!this.signupTypeApplyFilter(filter)) this.signupTypeIsSet = false;

    if (!this.signupNoteApplyFilter(filter)) this.signupNoteIsSet = false;

    if (!this.sequenceApplyFilter(filter)) this.sequenceIsSet = false;

    if (!this.purchasableStateApplyFilter(filter))
      this.purchasableStateIsSet = false;

    if (!this.purchaseDateApplyFilter(filter)) this.purchaseDateIsSet = false;

    if (!this.voidCloseIdApplyFilter(filter)) this.voidCloseIdIsSet = false;

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    if (!this.instanceIdApplyFilter(filter)) this.instanceIdIsSet = false;
    this.instanceId?.unassignAll(filter);

    if (!this.wlResultApplyFilter(filter)) this.wlResultIsSet = false;
    this.wlResult?.unassignAll(filter);

    if (!this.attendanceApplyFilter(filter)) this.attendanceIsSet = false;

    this.attendance?.forEach((a) => a.unassignAll(filter));
    if (!this.membershipUsedApplyFilter(filter))
      this.membershipUsedIsSet = false;
    this.membershipUsed?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseClassSignupDTOMeta.isDeleted,
      PurchaseClassSignupDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseClassSignupDTOMeta.isNew,
      PurchaseClassSignupDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseClassSignupDTOMeta.assignId,
      PurchaseClassSignupDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  priceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseClassSignupDTOMeta.price,
      PurchaseClassSignupDTOMeta,
      this.price,
      this,
    );
  }
  priceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceIsSet && this.priceApplyFilter(filter)) return true;

    return false;
  }
  signupDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseClassSignupDTOMeta.signupDatetime,
      PurchaseClassSignupDTOMeta,
      this.signupDatetime,
      this,
    );
  }
  signupDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupDatetimeIsSet && this.signupDatetimeApplyFilter(filter))
      return true;

    return false;
  }
  signupTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseClassSignupDTOMeta.signupType,
      PurchaseClassSignupDTOMeta,
      this.signupType,
      this,
    );
  }
  signupTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupTypeIsSet && this.signupTypeApplyFilter(filter)) return true;

    return false;
  }
  signupNoteApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseClassSignupDTOMeta.signupNote,
      PurchaseClassSignupDTOMeta,
      this.signupNote,
      this,
    );
  }
  signupNoteIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupNoteIsSet && this.signupNoteApplyFilter(filter)) return true;

    return false;
  }
  sequenceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseClassSignupDTOMeta.sequence,
      PurchaseClassSignupDTOMeta,
      this.sequence,
      this,
    );
  }
  sequenceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sequenceIsSet && this.sequenceApplyFilter(filter)) return true;

    return false;
  }
  purchasableStateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseClassSignupDTOMeta.purchasableState,
      PurchaseClassSignupDTOMeta,
      this.purchasableState,
      this,
    );
  }
  purchasableStateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchasableStateIsSet && this.purchasableStateApplyFilter(filter))
      return true;

    return false;
  }
  purchaseDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseClassSignupDTOMeta.purchaseDate,
      PurchaseClassSignupDTOMeta,
      this.purchaseDate,
      this,
    );
  }
  purchaseDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchaseDateIsSet && this.purchaseDateApplyFilter(filter))
      return true;

    return false;
  }
  voidCloseIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseClassSignupDTOMeta.voidCloseId,
      PurchaseClassSignupDTOMeta,
      this.voidCloseId,
      this,
    );
  }
  voidCloseIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.voidCloseIdIsSet && this.voidCloseIdApplyFilter(filter))
      return true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseClassSignupDTOMeta.personId,
      PurchaseClassSignupDTOMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  instanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseClassSignupDTOMeta.instanceId,
      PurchaseClassSignupDTOMeta,
      this.instanceId,
      this,
    );
  }
  instanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instanceIdIsSet && this.instanceIdApplyFilter(filter)) return true;
    return this.instanceId?.anySet(filter) == true;

    return false;
  }
  wlResultApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseClassSignupDTOMeta.wlResult,
      PurchaseClassSignupDTOMeta,
      this.wlResult,
      this,
    );
  }
  wlResultIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.wlResultIsSet && this.wlResultApplyFilter(filter)) return true;
    return this.wlResult?.anySet(filter) == true;

    return false;
  }
  attendanceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseClassSignupDTOMeta.attendance,
      PurchaseClassSignupDTOMeta,
      this.attendance,
      this,
    );
  }
  attendanceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.attendanceIsSet && this.attendanceApplyFilter(filter)) return true;

    return this.attendance?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  membershipUsedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseClassSignupDTOMeta.membershipUsed,
      PurchaseClassSignupDTOMeta,
      this.membershipUsed,
      this,
    );
  }
  membershipUsedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.membershipUsedIsSet && this.membershipUsedApplyFilter(filter))
      return true;
    return this.membershipUsed?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.priceIsSetDeep(filter)) return true;
    if (this.signupDatetimeIsSetDeep(filter)) return true;
    if (this.signupTypeIsSetDeep(filter)) return true;
    if (this.signupNoteIsSetDeep(filter)) return true;
    if (this.sequenceIsSetDeep(filter)) return true;
    if (this.purchasableStateIsSetDeep(filter)) return true;
    if (this.purchaseDateIsSetDeep(filter)) return true;
    if (this.voidCloseIdIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    if (this.instanceIdIsSetDeep(filter)) return true;
    if (this.wlResultIsSetDeep(filter)) return true;
    if (this.attendanceIsSetDeep(filter)) return true;
    if (this.membershipUsedIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
